// extracted by mini-css-extract-plugin
export default {"container":"HeaderLeft_container__-1FEq","backButton":"HeaderLeft_backButton__lnW7Q","title":"HeaderLeft_title__-13hM"};